module.exports = __webpack_public_path__ + "static/media/welcome-to-beatmatch.0d994fa2.png";